import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { useAuth } from '@/features/auth/useAuth'
import { loginSchema, type LoginForm } from '@/features/auth/schemas'
import { AuthShell } from '@/pages/AuthShell'
import { Button } from '@/shared/ui/Button'
import { Callout } from '@/shared/ui/Callout'
import { Field } from '@/shared/ui/Field'

export function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [formError, setFormError] = useState<string | null>(null)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginForm>({ resolver: zodResolver(loginSchema) })

  const onSubmit = async (values: LoginForm) => {
    setFormError(null)
    try {
      await login(values)
      navigate('/кабинет', { replace: true })
    } catch (error) {
      setFormError(
        error instanceof Error
          ? error.message
          : 'Не удалось войти. Попробуйте позже.',
      )
    }
  }

  return (
    <AuthShell
      title="Вход"
      footer={
        <>
          Нет аккаунта?{' '}
          <Link to="/регистрация" className="text-accent underline-offset-4 hover:underline">
            Зарегистрироваться
          </Link>
        </>
      }
    >
      <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        {formError && <Callout tone="error">{formError}</Callout>}
        <Field
          label="Email"
          type="email"
          autoComplete="email"
          autoFocus
          error={errors.email?.message}
          {...register('email')}
        />
        <Field
          label="Пароль"
          type="password"
          autoComplete="current-password"
          error={errors.password?.message}
          {...register('password')}
        />
        <Button type="submit" loading={isSubmitting} className="mt-1 w-full">
          Войти
        </Button>
      </form>
    </AuthShell>
  )
}
